import React, { Component } from 'react';
import i18next from "../../i18n";
import { urls, UserContext } from '../../constants';
import { Content } from '../Content';
import { getCurrentCompanyInfo } from '../helpers/HelperFunctions';
import { History } from '../helpers/History';
import PropTypes from 'prop-types';
export class ResponseStatusePage extends Component {
    static contextType = UserContext;
    static propTypes = {
        code: PropTypes.string.isRequired
    };
    constructor(props) {
        super(props);
        this.state = {
            currentCompanyName: ''
        };
    }
    componentDidMount() {
        if (!this.context) {
            getCurrentCompanyInfo().then((info) => { this.setState({ currentCompanyName: info?.name }); });
        }
    }
    render() {
        const { code } = this.props;
        // eslint-disable-next-line eqeqeq
        if (this.context && code != 500) {
            return (<Content>
                <div className="content">
                    <div className="_404">
                        <div className="_404-code">{code}</div>
                        <div className="_404-title">{i18next.t([`statusCode.${code}.Title`])}</div>
                        <div className="_404-sub-title">{i18next.t(`statusCode.${code}.SubTitle`)}</div>
                    </div>
                </div>
            </Content>);
        }
        else {
            return (<div className="form-page">
                <div className="form-block large-form">
                    <div className="form-header">
                        <div className="form-header-subtitle-right form-subtitle">{this.state.currentCompanyName}</div>
                    </div>
                    <div className="form-content">
                        <div className="form-group">
                            <div className="info-message-title">{code}</div>
                            <div className="info-message">{i18next.t(`statusCode.${code}.Title`)} {i18next.t(`statusCode.${code}.SubTitle`)}</div>
                        </div>
                        <div className="form-group form-group__last"><button className="btn btn-primary" onClick={() => History.push(urls.loginPageUrl)}>{i18next.t("ok")}</button></div>
                    </div>
                </div>
            </div>);
        }
    }
}